export const questions = [
  'Bagaimana cara akses full text repository?',
  'Bagaimana cara melakukan peminjaman buku di perpustakaan?',
  'Bagaimana cara melakukan pengembalian buku di perpustakaan?',
  'Bagaimana cara mengunjungi perpustakaan UPI?',
  'Dimana lokasi perpustakaan UPI?',
  'Kapan jam buka perpustakaan UPI?',
  'Apa yang harus dilakukan jika buku hilang?',
  'Bagaimana cara menghubungi CS Perpustakaan UPI?',
  'Bagaimana cara Unggah Mandiri Karya Ilmiah Perpustakaan UPI?',
  'Jenis karya ilmiah apa saja yang diterima?',
  'Bagaimana alur permohonan verifikasi karya ilmiah di Perpustakaan UPI?',
  'Apa saja fasilitas yang ada di lantai 1 perpustakaan UPI?',
  'Bagaimana cara melakukan perpanjangan peminjaman buku?',
  'Bagaimana cara mendapatkan surat bebas pinjam?',
  'Apakah mahasiswa diluar UPI bisa meminjam buku koleksi Perpustakaan UPI?',
  'Apakah mahasiswa diluar UPI boleh masuk ke Perpustakaan UPI?',
  'Apakah mahasiswa diluar UPI bisa mengakses koleksi repository?',
  'Bagaimana mendapatkan akses ke bab yang terkunci?',
  'Bagaimana mengakses layanan turnitin?',
  'Apakah mahasiswa bisa mengecek langsung similarity di Turnitin',
  'Apakah Perpustakaan UPI memiliki koleksi e-book?',
  'Bagaimana mengakses artikel jurnal dari database yang dilanggan bila ada di luar lingkungan UPI?',
  'Bagaimana mendapatkan akses ke data yang bisa menjadi pendukung penilaian akreditasi Prodi/Fakultas?',
  'Dimana saya bisa melihat penomoran untuk kode prodi?',
]
